export enum Role {
    Administrator = 'jjames-administrator',
    OperatorAdmin = 'jjames-operator-admin',
    OperatorMember = 'jjames-operator-member',
    OrganizationAdmin = 'jjames-organization-admin',
    OrganizationMember = 'jjames-organization-member',
    RegisteredParker = 'jjames-registered-parker',
    CameraDataExport = 'jjames-camera-data-export',
}